import { Col, Row, Radio, DatePicker, Button } from "antd";
import React, { useEffect, useState } from "react";
import Charts from "./chart";
import ResultChart from "./resultChart";
import InspectionApi from "../../../api/inspectionnew";
import moment from "moment";
import "./style.scss";
const { RangePicker } = DatePicker;

export default () => {
  const userInfo = sessionStorage.getItem("userInfo")
    ? JSON.parse(sessionStorage.getItem("userInfo"))
    : {};

  let stationId = -1;
  if (userInfo.stationIds) {
    userInfo.stationIds.includes(",")
      ? (stationId = userInfo.stationIds.split(",")[0] * 1)
      : (stationId = userInfo.stationIds * 1);
  }
  const [value, setValue] = useState("month");
  const [loading] = useState(false);
  const [time, setTime] = useState([moment().subtract(1, "months"), moment()]);
  const [taskInfo, setTaskInfo] = useState({});
  const [taskResultInfo, setTaskResultInfo] = useState({});
  const [chartData, setChartData] = useState({});
  const [resultChartData, setResultChartData] = useState({});
  const boxStyle = {
    height: 360,
    border: "1px solid #ddd",
    display: "flex",
    justifyContent: "space-between",
    padding: 20,
  };

  useEffect(() => {
    getPatrolTaskGroupStatistics();
    getPatrolTaskItemStatistics();
  }, [time]);

  const getPatrolTaskGroupStatistics = () => {
    const params = {
      stationId,
      startTime: time[0].format("YYYY-MM-DD") + " 00:00:00",
      endTime: time[1].format("YYYY-MM-DD") + " 23:59:59",
    };
    InspectionApi.getPatrolTaskGroupStatistics(params).then((res) => {
      if (res.status !== "0") return;
      const { unhandleNumber, handlingNumber, leakNumber, finishNumber } =
        res.data;
      setTaskInfo(res.data);
      setChartData({
        color: ["#FF0000", "#0099CC", "#FF682D", "#00CC00"], // 全局颜色列表
        tooltip: {
          trigger: "item",
        },
        legend: {
          left: "center",
        },
        series: [
          {
            name: "任务统计",
            type: "pie",
            radius: ["40%", "70%"],
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2,
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 20,
                fontWeight: "bold",
              },
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            data: [
              { value: unhandleNumber || 0, name: "未完成" },
              { value: handlingNumber || 0, name: "处理中" },
              { value: leakNumber || 0, name: "漏检" },
              { value: finishNumber || 0, name: "已完成" },
            ],
          },
        ],
      });
    });
  };

  const getPatrolTaskItemStatistics = () => {
    const params = {
      stationId,
      startTime: time[0].format("YYYY-MM-DD") + " 00:00:00",
      endTime: time[1].format("YYYY-MM-DD") + " 23:59:59",
    };
    InspectionApi.getPatrolTaskItemStatistics(params).then((res) => {
      if (res.status !== "0") return;
      const { unhandleNumber, handlingNumber, leakNumber, finishNumber } =
        res.data;
      setTaskResultInfo(res.data);
      setResultChartData({
        color: ["#FF0000", "#0099CC", "#FF682D"], // 全局颜色列表
        tooltip: {
          trigger: "item",
        },
        legend: {
          left: "center",
        },
        series: [
          {
            name: "结果统计",
            type: "pie",
            radius: ["40%", "70%"],
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2,
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 20,
                fontWeight: "bold",
              },
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            data: [
              { value: unhandleNumber || 0, name: "未完成" },
              { value: finishNumber || 0, name: "已完成" },
              { value: leakNumber || 0, name: "漏检" },
            ],
          },
        ],
      });
    });
  };

  const changeRadio = (e) => {
    const value = e.target.value;
    setValue(value);
    if (value === "month") {
      setTime([moment().subtract(1, "months"), moment()]);
    } else if (value === "square") {
      setTime([moment().subtract(3, "months"), moment()]);
    } else if (value === "year") {
      setTime([moment().subtract(1, "years"), moment()]);
    }
  };

  const search = () => {
    getPatrolTaskGroupStatistics();
    getPatrolTaskItemStatistics();
  };

  const reset = () => {
    setTime([moment().subtract(1, "months"), moment()]);
    setValue("month");
  };

  return (
    <div className="analyse-patrol" style={{ padding: 10 }}>
      <Row gutter={20}>
        <Col span={4}>
          <Radio.Group
            style={{ width: "100%" }}
            value={value}
            onChange={changeRadio}
            optionType="button"
            buttonStyle="solid"
          >
            <Radio.Button className="button-children" value="month">
              月
            </Radio.Button>
            <Radio.Button className="button-children" value="square">
              季度
            </Radio.Button>
            <Radio.Button className="button-children" value="year">
              年
            </Radio.Button>
          </Radio.Group>
        </Col>
        <Col span={6}>
          开始日期：
          <RangePicker value={time} onChange={(e) => setTime(e)} />
        </Col>
        <Col span={4}>
          <Button onClick={reset}>重置</Button>
          <Button
            onClick={search}
            type="primary"
            loading={loading}
            style={{ marginLeft: 8 }}
          >
            查询
          </Button>
        </Col>
      </Row>
      <Row style={{ marginTop: 20 }} gutter={20}>
        <Col span={12}>
          <div style={boxStyle}>
            <div className="chart-desc" style={{ width: "40%" }}>
              <h3>巡检任务统计</h3>
              <div style={{ margin: "20px 0" }}>
                <p>任务总数</p>
                <p className="total">{taskInfo.totalNumber || 0}</p>
              </div>
              <div style={{ display: "flex" }}>
                <div>
                  <p>未处理</p>
                  <p className="error">{taskInfo.unhandleNumber || 0}</p>
                </div>
                <div style={{ marginLeft: 20 }}>
                  <p>处理中</p>
                  <p className="primary">{taskInfo.handlingNumber || 0}</p>
                </div>
                <div style={{ marginLeft: 20 }}>
                  <p>漏检</p>
                  <p className="warning">{taskInfo.leakNumber || 0}</p>
                </div>
                <div style={{ marginLeft: 20 }}>
                  <p>已完成</p>
                  <p className="success">{taskInfo.finishNumber || 0}</p>
                </div>
              </div>
            </div>
            <div style={{ width: "60%", height: "100%" }}>
              <Charts id="taskCharts" height="100%" chartData={chartData} />
            </div>
          </div>
        </Col>
        <Col span={12}>
          <div style={boxStyle}>
            <div className="chart-desc" style={{ width: "40%" }}>
              <h3>巡检结果统计</h3>
              <div style={{ margin: "20px 0" }}>
                <p>巡检项总数</p>
                <p className="total">{taskResultInfo.totalNumber || 0}</p>
              </div>
              <div style={{ display: "flex" }}>
                <div>
                  <p>未处理</p>
                  <p className="error">{taskResultInfo.unhandleNumber || 0}</p>
                </div>
                <div style={{ marginLeft: 20 }}>
                  <p>已完成</p>
                  <p className="primary">
                    {taskResultInfo.finishNumber || 0}
                  </p>
                </div>
                <div style={{ marginLeft: 20 }}>
                  <p>漏检</p>
                  <p className="warning">{taskResultInfo.leakNumber || 0}</p>
                </div>
              </div>
            </div>
            <div style={{ width: "60%", height: "100%" }}>
              <ResultChart
                id="resultCharts"
                height="100%"
                chartData={resultChartData}
              />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};
